<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import {
  getKZValueDisplay,
  getKZValue,
  getKennungTitle,
  getKennungValueDisplay,
  getKennungValue,
} from "@/DataHelper";
import { getMonthNames } from "@/editor/CalenderHelper";
import { refreshFullPageContent } from "@/NavigationHelper";
import { Globals } from "@/Globals";
import { globalsKennung, globalsBezeichnung } from "@/local";
import BaseEditor from "@/components/BaseEditor.vue";
import { calcFunctionNew } from "@/CalcHelperStatic";
import { mountedBase, BaseSetup, reloadData } from "@/DataLoaderStatic";
import { showDialog } from "@/UIHelper";
const props = defineProps<{
  admin?: boolean;
  width?: number;
  zeitbereich?: any;
  aic?: number;
  heightLocal?: number;
  showReise?: boolean;
}>();
const emit = defineEmits<{
  back: [];
  reisename: any;
  freigabeReise: any;
}>();
let showAdresse = ref<boolean>(false);
let reiseClass: string = "grey lighten-2 pa-0 pl-2";
let showLoadingReise = ref<boolean>(false);
let sperre = ref<boolean>(false);
let kosten: string = "";
let showMemo = ref<boolean>(false);
let tooltip: string = "";
let tooltip1: string = "";
let modell: string = "RK_WebReiseabrechnungVollstaendig";
let modell1: string = "RK_Web_ReiseZurueckZiehen";
let anzahlTage: number = 0;
let items = ref<ListItems[]>([]);
let showCalc = ref<boolean>(false); // muss noch aus CREATE LIST übernommen werden!
let tab = ref<string>("");
let setCompKey = ref<number>(0);

const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_ReiseUebersichtBuchungen",
  aic: AUApi.Current.user.aic,
  emitBack: () => emit("back"),
};

const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));
onMounted(async () => {
  if (props.zeitbereich) {
    pageParams.zeitbereich = props.zeitbereich;
  }
  if (props.aic) {
    pageParams.aic = props.aic;
  }
  const begriffModell = globalsKennung(Globals.Begriff, modell);
  if (begriffModell) {
    tooltip = begriffModell.tooltip;
  }
  const begriffModell1 = globalsKennung(Globals.Begriff, modell1);
  if (begriffModell1) {
    tooltip1 = begriffModell1.tooltip;
  }
  setSizes();
  await mountedBase(uiData, pageParams);
  if (!uiData.showLoading && uiData.data) {
    const row = uiData.data[0];
    const adresse = getKennungTitle("ADDRESSEE", uiData.columns);
    if (adresse) {
      showAdresse.value = true;
    }
    if (row) {
      sperre = getKZValue(row, "sperre", uiData.columns);
      let reiseName = getKennungValue(row, "BEZEICHNUNG", uiData.columns);
      const status = getKZValueDisplay(row, "status", uiData.columns);
      reiseName = reiseName + " (" + status + ")";
      const anzahlReisen = uiData.data.length;
      const beginnReise = getKZValueDisplay(row, "Beginn", uiData.columns) ?? "";
      const endeReise = getKZValueDisplay(row, "Ende", uiData.columns) ?? "";

      emit("reisename", reiseName, beginnReise, endeReise, anzahlReisen);
      refreshItems();
    }
  }
});
function setSizes() {
  // if (Constants.isMobile && $isPhone()) {
  //   width = window.innerWidth;
  // }
}
function onBack() {
  // reveal.value = false;
  reloadData(uiData, pageParams);
}
function back() {
  // reveal1.value = false;
  reloadData(uiData, pageParams);
}
async function refreshItems() {
  items.value = [];
  for (let i = 0; i < uiData.data.length; i++) {
    const row = uiData.data[i];
    const kosten = getKZValueDisplay(row, "kosten", uiData.columns);
    const km = getKZValueDisplay(row, "km", uiData.columns);
    const belege = getKZValueDisplay(row, "belege", uiData.columns);
    const diaten = getKZValueDisplay(row, "diaten", uiData.columns);
    const sperre = getKZValue(row, "sperre", uiData.columns); // Status !== 100
    const ende = getKZValueDisplay(row, "Ende", uiData.columns);
    const endeDate = getKZValue(row, "Ende", uiData.columns);
    showMemo = getKZValue(row, "showMemo", uiData.columns);
    if (ende && !sperre) {
      showCalc.value = true;
    }
    let abgeschlossen = getKZValue(row, "abgeschlossen", uiData.columns); // monat LV = Übergleitet
    let textAbg = "";
    if (abgeschlossen) {
      abgeschlossen = new Date(abgeschlossen);
      textAbg = getMonthNames()[abgeschlossen.getMonth()];
    }
    let title = getKZValueDisplay(row, "subject", uiData.columns);
    const title2 = getKZValueDisplay(row, "Beginn", uiData.columns);
    const subtitel = getKZValueDisplay(row, "Ende", uiData.columns);
    const status = getKZValueDisplay(row, "status", uiData.columns);
    const anzahlTage = getKZValue(row, "Tage", uiData.columns);

    // let cssClass = "text-primary";
    if (abgeschlossen) {
      // cssClass = "text-success";
      title = title + " (bezahlt: " + textAbg + ")";
    } else if (status) {
      // cssClass = "text-info";
      title = title + " (" + status + ")";
    }
    const memo = getKZValueDisplay(row, "memo", uiData.columns);
    const kostenstelle = getKennungValueDisplay(
      row,
      "KOSTENSTELLENZUORDNG",
      uiData.columns
    );
    items.value.push({
      title,
      title2,
      subtitel,
      divider: true,
      inset: true,
      aic: row.aic_Stamm,
      menu: false,
      flex: 12,
      memo,
      kostenstelle,
      // cssClass,
      sperre,
      number: anzahlTage,
      subtitel1: kosten,
      expand: false,
      select: false,
      date: endeDate,
      subtitelHeader: belege,
      differenz: km,
      differenzValue: diaten,
    });
    showLoadingReise.value = false;
  }
}
function openKostenersatz(
  nameReise?: string | undefined,
  aicReise?: number,
  sperre?: boolean,
  anzahlTage?: number,
  endeDatum?: Date
) {
  // let showFullscreen = false;
  // if (Constants.isMobile && isPhone()) {
  //   showFullscreen = true;
  // }
  let sperreNacht = false;
  if (pageParams.zeitbereich) {
    const von = pageParams.zeitbereich.von;
    if (endeDatum) {
      const end = new Date(endeDatum);
      if (end.valueOf() === von.valueOf()) {
        sperreNacht = true;
      }
    }
  }
  const navData = {
    zeitbereich: pageParams.zeitbereich,
    nameReise,
    aicReise,
    sperre,
    anzahlTage,
    onReloadData: false,
    sperreNacht,
  };
  showDialog({
    title: globalsBezeichnung(Globals.Begriff, "Reise", "Reise bearbeiten"),
    site: "RkMitarbeiterReiseUebersicht",
    data: navData,
    fullscreen: true,
    onClose: () => {
      if (navData.onReloadData === true) {
        if (anzahlTage !== 0 && anzahlTage !== null) {
          refreshFullPageContent();
        } else {
          fullReload();
        }
      }
      return true;
    },
  });
}
async function fullReload() {
  uiData.initialized = false;
  await reloadData(uiData, pageParams);
  await refreshItems();
  setCompKey.value += +1;
  const row = uiData.data[0];
  const sperre = getKZValue(row, "sperre", uiData.columns);
  let reiseName = getKennungValue(row, "BEZEICHNUNG", uiData.columns);
  const status = getKZValueDisplay(row, "status", uiData.columns);
  reiseName = reiseName + " (" + status + ")";
  if (uiData.data.length > 1) {
    reiseName = reiseName + " +1";
  }
  const beginnReise = getKZValueDisplay(row, "Beginn", uiData.columns) ?? "";
  const endeReise = getKZValueDisplay(row, "Ende", uiData.columns) ?? "";
  emit("reisename", reiseName, beginnReise, endeReise);
}
function onCalcFunction(modell: string, aic: number, anzahlTage?: number) {
  if (modell) {
    calcFunctionNew(modell, aic, false, onCalculated, pageParams.zeitbereich, []);
  }
}
async function onCalculated() {
  showCalc.value = false;
  showLoadingReise.value = true;
  if (anzahlTage !== 0 && anzahlTage !== null) {
    setTimeout(() => refreshFullPageContent());
  } else {
    await fullReload();
  }
  emit("freigabeReise");
}
</script>
<template>
  <v-sheet
    class="align-self-start"
    style="background: transparent; width: 100%; display: block"
    v-if="showReise"
    :key="setCompKey"
  >
    <v-row density="compact">
      <v-col v-for="(item, index) in items" :key="'c' + index" :cols="item.flex">
        <v-card :class="reiseClass" :loading="showLoadingReise">
          <v-list-item class="pa-0">
            <v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
            <v-container class="pa-0">
              <div>
                {{ globalsBezeichnung(Globals.Begriff, "Web_Beginn", "Beginn") }}:
                {{ item.title2 }}
              </div>
              <v-row>
                <v-col class="dvhCol" cols="6" xs="6" sm="6">
                  <div>
                    {{ globalsBezeichnung(Globals.Begriff, "Web_Ende", "Ende") }}:
                    {{ item.subtitel }}
                  </div>
                </v-col>

                <v-col class="text-end pt-0 pb-2">
                  <span class="text-error pr-4">&sum; {{ item.subtitel1 }}</span>
                </v-col>
              </v-row>
              <v-row no-gutters class="pa-0">
                <v-col cols="4" class="caption py-1"
                  >Diäten: {{ item.differenzValue }}</v-col
                >

                <v-col cols="4" class="caption py-1"
                  >{{
                    globalsBezeichnung(Globals.Begriff, "Web_Button_Beleg", "Belege")
                  }}: {{ item.subtitelHeader }}</v-col
                >
                <v-col cols="4" class="caption py-1">
                  km Geld: {{ item.differenz }}</v-col
                >
              </v-row>
              <!-- <v-divider color="error"></v-divider>
              <v-row class="pa-0 my-0">
                <v-col class="text-end pt-0 pb-2">
                  <span class="text-error pr-4"
                    >&sum; {{ item.subtitel1 }}</span
                  >
                </v-col>
              </v-row> -->
            </v-container>
          </v-list-item>

          <v-tabs
            v-model="tab"
            class="my-4 pa-0 d-flex flex-wrap"
            density="compact"
            tile
            slim
          >
            <v-tab v-if="!admin" value="one">
              {{ globalsBezeichnung(Globals.Begriff, "Status", "Status") }}</v-tab
            >
            <v-tab v-if="!admin" value="two">
              {{ globalsBezeichnung(Globals.Begriff, "Details", "Details") }}
            </v-tab>
            <v-tab
              value="three"
              @click="
                openKostenersatz(
                  item.title,
                  item.aic,
                  item.sperre,
                  item.number,
                  item.date
                )
              "
            >
              {{ globalsBezeichnung(Globals.Begriff, "Web_Button_Beleg", "Belege") }}
            </v-tab>
          </v-tabs>
          <v-tabs-window v-model="tab">
            <v-tabs-window-item
              value="one"
              bg-color="success"
              :style="{
                backgroundColor: '#f7f8fa',
                border: '1px solid #e6e6e6',
                borderRadius: '6px',
                padding: '10px',
              }"
            >
              <v-card class="pa-0 pt-2" tile density="compact">
                <RkMitarbeiterTemplateReiseStatus
                  ref="statusInfo"
                  query="Web_Reise_Status_Anzeige"
                  :zeitbereich="pageParams.zeitbereich"
                  :aic="item.aic"
                  :showInfo="showMemo"
                />
                <v-card-actions v-if="showCalc">
                  <v-tooltip location="bottom" :text="tooltip">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        eager
                        prepend-icon="mdi-check"
                        v-if="modell && showCalc"
                        @click="onCalcFunction(modell, item.aic ?? 0)"
                        color="success"
                        variant="flat"
                        rounded="0"
                      >
                        <span>{{
                          globalsBezeichnung(
                            Globals.Begriff,
                            "RK_WebReiseabrechnungVollstaendig",
                            "vollständig"
                          )
                        }}</span>
                      </v-btn>
                    </template>
                  </v-tooltip>

                  <v-tooltip location="bottom" :text="tooltip">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        prepend-icon="mdi-cancel"
                        v-if="modell1 && showCalc"
                        @click="onCalcFunction(modell1, item.aic ?? 0, item.number)"
                        color="error"
                        variant="flat"
                        rounded="0"
                      >
                        <span>{{
                          globalsBezeichnung(
                            Globals.Begriff,
                            "RK_Web_ReiseZurueckZiehen",
                            "zurückziehen"
                          )
                        }}</span>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </v-card-actions>
              </v-card>
            </v-tabs-window-item>
            <v-tabs-window-item
              value="two"
              :style="{
                backgroundColor: '#f7f8fa',
                border: '1px solid #e6e6e6',
                borderRadius: '6px',
                padding: '0px',
              }"
            >
              <BaseEditor
                :numberOfColumns="12"
                @back="onBack()"
                :aic="item.aic"
                :zeitbereich="pageParams.zeitbereich"
                :showTitle="false"
                query="Web_ReiseDatenAnpassen"
                :backOnSave="true"
                :showDeleteButton="false"
                :readonly="item.sperre"
                :maxHeight="props.heightLocal ?? 300"
              />
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<style scopes>
.dvhCard {
  margin-bottom: 0px;
  width: 100%;
  padding-top: 10px;
  padding-right: 0px;
  overflow-y: scroll;
  min-height: 100%;
}
</style>
